export default __webpack_public_path__ + "static/media/product-approve.72cf461b.svg";